<template>
  <div>
    <table class="table table-dark table-hover">
      <thead>
        <tr>
          <th class="text-center text-uppercase font-weight-bold">Horário</th>
          <th class="text-center text-uppercase font-weight-bold">Clima</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center font-weight-light">
            <img
              :src="field.time.img"
              :alt="field.time.value"
              :title="field.time.value"
              class="img-fluid"
            />
          </td>
          <td class="text-center font-weight-light">
            <img
              :src="field.weather.img"
              :alt="field.weather.value"
              :title="field.weather.value"
              class="img-fluid"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table table-dark table-bordered">
      <thead>
        <tr>
          <th
            class="text-center text-uppercase font-weight-bold"
            :colspan="colsRows"
          >
            CAMPO
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in completeField" :key="index">
          <td v-for="(col, index) in row" :key="index" class="text-center p-0">
            <img
              :src="col.img"
              :alt="col.value"
              :title="col.value"
              class="img-fluid"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { areas } from '../data/field'
import { getRandom } from '../utils/randomPicker'

export default {
  name: 'field-table',

  props: {
    field: { type: Object, required: true }
  },

  computed: {
    colsRows() {
      switch (this.field.type) {
        case 'small':
          return 2
        case 'medium':
          return 3
        case 'large':
          return 4
        default:
          return 2
      }
    },

    completeField() {
      const complete = []

      for (let i = 0; i < this.colsRows; i++) {
        const row = []
        for (let j = 0; j < this.colsRows; j++) {
          row[j] = getRandom(areas)
        }
        complete[i] = row
      }

      return complete
    }
  }
}
</script>
